"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Meeting = function Meeting(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M69 94a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V82c0-9.093-7.592-16.5-17-16.5H24c-9.408 0-17 7.407-17 16.5v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V82c0-12.998 10.764-23.5 24-23.5h21c13.236 0 24 10.502 24 23.5v12zm27 0a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V82c0-9.093-7.592-16.5-17-16.5v-7c13.236 0 24 10.502 24 23.5v12zM34.5 48.5c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm0-7c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.611 17 17 17zM63 0c13.255 0 24 10.745 24 24S76.255 48 63 48v-7c9.389 0 17-7.611 17-17S72.389 7 63 7V0z",
    fill: "currentColor"
  })));
};
var _default = exports.default = Meeting;